// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { customerSelectorToolbarStyles } from "@insite/content-library/Components/CustomerSelectorToolbar";
import { css } from "styled-components";

customerSelectorToolbarStyles.narrowHidden = {
    above: "sm",
    css: css`
        position: absolute;
        right: 15px;
        @media only screen and (max-width: 769px) {
            top: 5px;
        }
        @media only screen and (max-width: 415px) {
            top: 35px;
        }
    `,
};

customerSelectorToolbarStyles.overflowMenu = {
    cssOverrides: {
        wrapper: css`
            margin-left: 10px;
            > button {
                &:hover {
                    background: white;
                    border-color: white;
                }
            }
        `,
    },
};
